angular.module('app.directives').directive('vpAreaReadonly', () => ({
    restrict: 'EA',

    scope: {
        model: '<',
    },

    controller($scope) {},

    templateUrl: '/directives/area/area-readonly.html',
}));
